import React, {useEffect} from 'react';
import {Result} from "antd";
import {useDocumentTitle} from "usehooks-ts";
import {useFavicon} from "../hooks/useFavicon";

export interface INotFoundProps {

}

const NotFoundProps: React.FC<INotFoundProps> = ({}) => {

    useDocumentTitle("Co-Hr Performance Application");
    useFavicon(``)

    
    useEffect(() => {
        console.log(window.location.href);
    }, []);
    
    return (<>
        <div className={"h-screen w-screen flex items-center justify-center"}>
            <Result
                status="404"
                title="404"
                subTitle="Aradığınız sayfaya ulaşılamıyor"
            />
        </div>
    </>)
};

export default NotFoundProps;